import { render, staticRenderFns } from "./VatNameFilter.vue?vue&type=template&id=c6486ba8&scoped=true"
import script from "./VatNameFilter.vue?vue&type=script&lang=js"
export * from "./VatNameFilter.vue?vue&type=script&lang=js"
import style0 from "./VatNameFilter.vue?vue&type=style&index=0&id=c6486ba8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6486ba8",
  null
  
)

export default component.exports